import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConsultationCard = ({ consultation, onAccept, onViewDetails }) => {
  const getUrgencyColor = (urgency) => {
    switch (urgency) {
      case 'high':
        return 'text-error bg-error/10';
      case 'medium':
        return 'text-warning bg-warning/10';
      case 'low':
        return 'text-success bg-success/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getUrgencyText = (urgency) => {
    switch (urgency) {
      case 'high':
        return 'فوری';
      case 'medium':
        return 'متوسط';
      case 'low':
        return 'عادی';
      default:
        return 'نامشخص';
    }
  };

  const formatTimeRemaining = (deadline) => {
    const now = new Date();
    const deadlineDate = new Date(deadline);
    const diffHours = Math.ceil((deadlineDate - now) / (1000 * 60 * 60));
    
    if (diffHours <= 0) return 'منقضی شده';
    if (diffHours < 24) return `${diffHours} ساعت باقی‌مانده`;
    const diffDays = Math.ceil(diffHours / 24);
    return `${diffDays} روز باقی‌مانده`;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-moderate transition-all duration-200">
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-reverse space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
            <Icon name="User" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-card-foreground">{consultation?.clientName}</h3>
            <p className="text-sm text-muted-foreground">{consultation?.clientEmail}</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-reverse space-x-2">
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getUrgencyColor(consultation?.urgency)}`}>
            {getUrgencyText(consultation?.urgency)}
          </span>
          <span className="text-xs text-muted-foreground">
            {consultation?.category}
          </span>
        </div>
      </div>
      {/* Question Preview */}
      <div className="mb-4">
        <h4 className="font-medium text-card-foreground mb-2">موضوع مشاوره:</h4>
        <p className="text-sm text-muted-foreground line-clamp-3 leading-relaxed">
          {consultation?.question}
        </p>
      </div>
      {/* Metadata */}
      <div className="flex items-center justify-between text-xs text-muted-foreground mb-4">
        <div className="flex items-center space-x-reverse space-x-4">
          <span className="flex items-center">
            <Icon name="Clock" size={14} className="ml-1" />
            {consultation?.submittedAt}
          </span>
          <span className="flex items-center">
            <Icon name="MessageSquare" size={14} className="ml-1" />
            {consultation?.messageCount} پیام
          </span>
        </div>
        <span className={`font-medium ${
          consultation?.deadline && new Date(consultation.deadline) < new Date() 
            ? 'text-error' :'text-warning'
        }`}>
          {consultation?.deadline ? formatTimeRemaining(consultation?.deadline) : 'بدون مهلت'}
        </span>
      </div>
      {/* Actions */}
      <div className="flex items-center space-x-reverse space-x-3">
        <Button
          variant="default"
          size="sm"
          onClick={() => onAccept(consultation?.id)}
          iconName="MessageSquare"
          iconPosition="right"
          className="flex-1"
        >
          پاسخ سریع
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onViewDetails(consultation?.id)}
          iconName="Eye"
          iconPosition="right"
          className="flex-1"
        >
          مشاهده جزئیات
        </Button>
      </div>
    </div>
  );
};

export default ConsultationCard;